import React from 'react'
import { RateInput } from 'components/template/TemplateForm'
import ErrorMessage from 'components/common/ErrorMessage'
import { useTranslation } from 'react-i18next'

const TranslationTiers = ({ languageTiers, control, errors, item }) => {
  const { t } = useTranslation();
  return (
    <>
      {languageTiers && languageTiers?.map((val, index) => {
        return (
          <React.Fragment key={`translation-tier-${index}`}>
            <div className="row-primary mt-3 mb-5 justify-content-center">
              <h2 className='fw-bold text-center text-uppercase'>{t('accountForm.translationRates')}</h2>
            </div>
            <div className='row-primary rate_container_outer'>
              <h2 className='fw-bold text-uppercase'>{val?.name || val?.tiers[0]?.name || t('common.nA')}</h2>

              <div className='rate_container_wrapper w-100'>
                <div className='template_create rate_container'>
                  <div className="row-primary align-items-end inner">
                    <h2 className='mb-3 my-0'>{t('templateForm.rates').replace(/:$/, '')}</h2>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>{t('translationTiers.translation')}</h4>
                      <span className='static-unit-text'>{t('translationTiers.perWord')}</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.translation_rate.${index}`} placeholder={t('translationTiers.translationRate')} currency_symbol={true} />
                      </div>
                    </div>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>{t('translationTiers.editing')}</h4>
                      <span className='static-unit-text'>{t('translationTiers.perWord')}</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.editing_rate.${index}`} placeholder={t('translationTiers.editingRate')} currency_symbol={true} />
                      </div>
                    </div>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>{t('translationTiers.dtp')}</h4>
                      <span className='static-unit-text'>{t('translationTiers.perWork')}</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.dtp_rate.${index}`} placeholder={t('translationTiers.dtpRate')} currency_symbol={true} />
                      </div>
                    </div>

                    {/* <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>Review</h4>
                      <span className='static-unit-text'>per page</span>
                      <div className='create inter_wrapper'>
                        <RateInput control={control} name={`translationRates.review_rate.${index}`} placeholder='Review rate' currency_symbol={true} />
                      </div>
                    </div> */}
                  </div>

                  <div className="row-primary align-items-end inner">
                    <h2 className='mb-3 my-0'>{t('templateForm.rates').replace(/:$/, '')}</h2>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>{t('translationTiers.review')}</h4>
                      <span className='static-unit-text'>{t('translationTiers.perPage')}</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.review_rate.${index}`} placeholder={t('translationTiers.reviewRate')} currency_symbol={true} />
                      </div>
                    </div>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>{t('translationTiers.audioRecording')}</h4>
                      <span className='static-unit-text'>{t('translationTiers.perWord')}</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.audio_recording_rate.${index}`} placeholder={t('translationTiers.audioRecordingRate')} currency_symbol={true} />
                      </div>
                    </div>

                    <div className='Inter_rate_row'>
                      <h4 className='text-center fw-bold fst-italic'>{t('translationTiers.transcription')}</h4>
                      <span className='static-unit-text'>{t('translationTiers.perAudioMinute')}</span>
                      <div className='create inter_wrapper translation_rate_input'>
                        <RateInput control={control} name={`translationRates.transcription_rate.${index}`} placeholder={t('translationTiers.transcriptionRate')} currency_symbol={true} />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )
      })}
    </>
  )
}

export default TranslationTiers
